/* Hempy Club storefront: talks to the club server through the Shopify App Proxy (/apps/club). */
(function () {
  var API = '/apps/club';
  var REASONS = {
    join_bonus: 'מתנת הצטרפות',
    profile_bonus: 'השלמת פרופיל',
    order_earn: 'קנייה',
    second_order_bonus: 'בונוס קנייה שנייה',
    tier_upgrade_bonus: 'מתנת עלייה בדרגה',
    refund: 'החזרה',
    cancel: 'ביטול הזמנה',
    redemption: 'מימוש',
    redemption_restored: 'קוד שלא נוצל - הנקודות הוחזרו',
    expiry: 'פג תוקף',
    manual_adjust: 'עדכון ידני',
    review: 'ביקורת',
    referral: 'חבר מביא חבר',
    instagram: 'אינסטגרם',
    telegram: 'טלגרם'
  };

  // Program settings (Declub admin → "תוכנית"), passed by the theme in #hc-data (and refreshed by /status).
  // Until they arrive, Happy Hempy's values are used.
  var PG = null, HC = {};
  try {
    var hcEl = document.getElementById('hc-data');
    if (hcEl) { HC = JSON.parse(hcEl.textContent) || {}; PG = normalizeProgram(HC.program); }
  } catch (e) {}
  /** The shop metafield holds the full program; /status sends a flatter copy. Both end up in the flat shape. */
  function normalizeProgram(p) {
    if (!p || !p.currency) return p || null;
    return {
      mode: p.currency.mode, name: p.currency.name, point_value: p.currency.point_value,
      earn: p.earn && p.earn.per_100, join_gift: p.join_gift, second_order: p.second_order, birthday: p.birthday,
      referral: p.referral, instagram: p.instagram, redeem: p.redeem, tiers: p.tiers,
      expiry_months: p.expiry && p.expiry.months, campaigns: p.campaigns || [], branding: p.branding || {}
    };
  }
  function pg(path, d) {
    var v = PG;
    path.split('.').forEach(function (k) { v = v == null ? v : v[k]; });
    return v == null ? d : v;
  }
  function isPoints() { return pg('mode', 'cashback') === 'points'; }
  /** "20 ₪" (cashback) or "200 נקודות" (points). */
  function amt(n) { n = Math.round(Number(n) || 0); return isPoints() ? n.toLocaleString('he-IL') + ' ' + pg('name', 'נקודות') : n + ' ₪'; }
  function shk(points) { return Math.round((Number(points) || 0) * pg('point_value', 1) * 100) / 100; }
  function maxShare() { return pg('redeem.max_share', 30); }
  function giftAmt() { return pg('join_gift.amount', 20); }
  function friendTotal() { return giftAmt() + pg('referral.friend_bonus', 10); }
  /** A bonus-points campaign running now (from the theme data). */
  function activeCampaign() {
    var now = Date.now();
    var list = (PG && PG.campaigns) || [];
    var on = list.filter(function (c) { return c.enabled !== false && new Date(c.starts_at) <= now && new Date(c.ends_at) > now; })
      .sort(function (a, b) { return (b.type === 'multiplier' || !b.type ? b.multiplier : 1) - (a.type === 'multiplier' || !a.type ? a.multiplier : 1); })[0];
    return on ? Object.assign({ active: true }, on) : null;
  }
  /** One line about the running campaign, by type. */
  function campaignText(c) {
    var min = Number(c.min_order) || 0;
    var over = min ? ' בהזמנה מעל ' + min + ' ₪' : '';
    if (c.type === 'bonus') return '+' + amt(c.bonus) + ' לחברי המועדון' + over;
    if (c.type === 'free_shipping') return 'משלוח חינם לחברי המועדון' + over;
    if (c.type === 'gift') return 'מתנה לחברי המועדון' + (c.gift_title ? ': ' + c.gift_title : '') + over;
    return 'פי ' + c.multiplier + ' נקודות על כל קנייה';
  }
  function tierRateOf(tier) {
    var on = pg('tiers.enabled', true);
    return Number(pg('earn.' + (on ? tier : 'bronze'), pg('earn.bronze', 5))) || 0;
  }

  function call(path, body) {
    return fetch(API + '/' + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.program) PG = Object.assign({ campaigns: (PG && PG.campaigns) || [], branding: (PG && PG.branding) || {} }, j.program);
        return j;
      })
      .catch(function () { return { ok: false, message: 'אירעה שגיאה, נסו שוב בעוד רגע' }; });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function applyCode(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    });
  }

  // A club code stays in the cart when the cart drops below the code's minimum, and Shopify re-applies it
  // by itself once the cart grows back, so the customer can't choose again. When the cart shows the
  // "how much to use" block, such a waiting code is cancelled (its points go back) and taken out of the cart.
  function cleanStaleCodes() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = c.discount_codes || [];
        var stale = codes.filter(function (d) { return /HEMPY-/i.test(d.code) && !d.applicable; });
        if (!stale.length) return;
        var keep = codes.filter(function (d) { return stale.indexOf(d) < 0; }).map(function (d) { return d.code; }).join(',');
        return Promise.all(stale.filter(function (d) { return !/BDAY/i.test(d.code); }).map(function (d) {
          return call('unredeem', { code: d.code });
        })).then(function () { return applyCode(keep); });
      })
      .catch(function () {});
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  // ---------- cart drawer ----------
  function setupCart(el) {
    var subtotal = Number(el.dataset.subtotal || 0) / 100;
    var msg = el.querySelector('[data-hc-msg]');
    var btn = el.querySelector('[data-hc-redeem]');
    if (!msg || !btn) return;
    cleanStaleCodes().then(function () { return call('status'); }).then(function (s) {
      if (!s.ok || !s.member) return;
      if (s.birthday) addBirthdayButton(el, s.birthday);
      if (s.join_gift && s.join_gift.status === 'usable' && left(s.join_gift.expires_at)) {
        var g = document.createElement('div');
        g.className = 'hc-cart__gift';
        g.setAttribute('data-hc-countdown-box', '');
        g.innerHTML = '⏳ ' + amt(giftAmt()) + ' מתנת ההצטרפות שלך: <b data-hc-countdown="' + esc(s.join_gift.expires_at) + '"></b>';
        el.insertBefore(g, el.firstChild);
        startCountdowns(el);
      }
      var step = isPoints() ? Math.max(1, Math.round(1 / pg('point_value', 1))) : 1;
      var maxPts = Math.min(s.redeemable_points, Math.floor((subtotal * maxShare() / 100) / pg('point_value', 1) + 1e-9));
      maxPts = Math.floor(maxPts / step) * step;
      el.hidden = false;
      cartNotes(el, s);
      if (!s.can_redeem) {
        msg.innerHTML = 'יש לך <b>' + s.balance + '</b> נקודות. ' + esc(s.redeem_blocked_reason);
        return;
      }
      var minOrder = Number(pg('redeem.min_order', 0)) || 0;
      if (minOrder && subtotal < minOrder) {
        msg.innerHTML = 'יש לך <b>' + s.balance + '</b> נקודות. אפשר להשתמש בהן בהזמנה מעל ' + minOrder + ' ₪, חסרים לך עוד <b>' +
          Math.ceil(minOrder - subtotal) + ' ₪</b>.';
        return;
      }
      if (maxPts < s.min_redeem) {
        msg.innerHTML = 'יש לך <b>' + s.balance + '</b> נקודות. אפשר להשתמש בנקודות עד ' + maxShare() + '% מסכום הסל, הוסיפו עוד מוצר כדי לממש.';
        return;
      }
      // Like Smile's incremental reward: the customer picks how much to use (default = the most allowed).
      var pts = maxPts;
      var choose = maxPts - s.min_redeem >= step;
      msg.innerHTML = 'יש לך <b>' + s.balance + '</b> נקודות = ' + shk(s.balance) + ' ₪' +
        (choose
          ? '<label class="hc-slider"><span>כמה להשתמש עכשיו?</span>' +
            '<input type="range" min="' + s.min_redeem + '" max="' + maxPts + '" step="' + step + '" value="' + maxPts + '" data-hc-range aria-label="כמה נקודות לממש">' +
            '<span class="hc-slider__ends"><span>' + s.min_redeem + '</span><span>' + maxPts + '</span></span></label>'
          : '') +
        '<small>לא בשילוב קוד קופון נוסף. מה שלא משתמשים בו נשאר בחשבון לקנייה הבאה.</small>';
      function label() { btn.textContent = 'השתמש ב-' + pts + ' נקודות (' + shk(pts) + ' ₪ הנחה)'; }
      var range = msg.querySelector('[data-hc-range]');
      if (range) range.addEventListener('input', function () { pts = Number(range.value); label(); });
      label();
      btn.hidden = false;
      btn.onclick = function () {
        btn.disabled = true;
        if (range) range.disabled = true;
        btn.textContent = 'רגע...';
        var existing = (s.active_codes || []).find(function (c) { return Number(c.points) === pts && Number(c.min_subtotal) <= subtotal; });
        var getCode = existing
          ? Promise.resolve({ ok: true, code: existing.discount_code })
          : call('redeem', { points: pts });
        getCode.then(function (r) {
          if (!r.ok) {
            msg.textContent = r.message || 'לא ניתן לממש כרגע';
            btn.disabled = false;
            btn.textContent = 'נסו שוב';
            return;
          }
          return applyCode(r.code).then(refreshCartDrawer);
        });
      };
    });
  }

  /** Campaign + expiry notes in the cart (both push the customer to use / earn now). */
  function cartNotes(el, s) {
    var notes = [];
    var c = s.campaign || activeCampaign();
    if (c && c.active) notes.push('🔥 <b>' + esc(c.name) + ':</b> ' + esc(campaignText(c)) + ', עד ' + dateHe(c.ends_at));
    var exp = s.profile && s.profile.points_expire_at;
    if (exp && new Date(exp) - Date.now() < 30 * 86400000 && s.balance > 0) {
      notes.push('⏳ <b>' + amt(s.balance) + ' יפוגו ב-' + dateHe(exp) + '.</b> זה הזמן להשתמש בהם (קנייה חדשה מאריכה את התוקף)');
    }
    notes.forEach(function (n) {
      var d = document.createElement('div');
      d.className = 'hc-cart__note';
      d.innerHTML = n;
      el.insertBefore(d, el.firstChild);
    });
  }

  function useBirthday(btn, onDone) {
    btn.disabled = true;
    btn.textContent = 'רגע...';
    call('birthday', {}).then(function (r) {
      if (!r.ok || !r.code) {
        btn.disabled = false;
        btn.textContent = r.message || 'נסו שוב';
        return;
      }
      applyCode(r.code).then(onDone);
    });
  }

  function addBirthdayButton(el, b) {
    var wrap = document.createElement('div');
    wrap.className = 'hc-bday';
    wrap.innerHTML = '<span>🎂 יום הולדת שמח! ' + b.percent + '% הנחה על קנייה אחת החודש</span>';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--secondary';
    btn.textContent = 'השתמש בהנחת יום ההולדת (במקום הנקודות)';
    btn.onclick = function () { useBirthday(btn, refreshCartDrawer); };
    wrap.appendChild(btn);
    el.appendChild(wrap);
  }

  function initCarts() {
    document.querySelectorAll('[data-hc-cart]:not([data-hc-ready])').forEach(function (el) {
      el.setAttribute('data-hc-ready', '');
      setupCart(el);
    });
    document.querySelectorAll('[data-hc-unredeem]:not([data-hc-ready])').forEach(setupUndo);
  }

  // "ביטול" after using points: the code leaves the cart and the points go back to the balance
  // (a birthday code just leaves the cart and stays valid).
  function setupUndo(btn) {
    btn.setAttribute('data-hc-ready', '');
    btn.onclick = function () {
      btn.disabled = true;
      btn.textContent = 'רגע...';
      var undo = btn.hasAttribute('data-hc-bday')
        ? Promise.resolve({ ok: true })
        : call('unredeem', { code: btn.getAttribute('data-hc-unredeem') });
      undo.then(function (r) {
        if (!r.ok && r.error !== 'not_active') {
          btn.textContent = r.message || 'לא ניתן לבטל כרגע';
          if (r.error !== 'used') setTimeout(function () { btn.disabled = false; btn.textContent = 'ביטול'; }, 2500);
          return;
        }
        return applyCode('').then(refreshCartDrawer);
      }).catch(function () { btn.disabled = false; btn.textContent = 'ביטול'; });
    };
  }

  // ---------- club page ----------
  function tierProgress(s) {
    if (!s.next_tier) return '<p class="hc-muted">את/ה בדרגה הגבוהה ביותר. תודה שאת/ה איתנו 💚</p>';
    var n = s.next_tier;
    return (
      '<p>' + needText(n.orders_needed, n.amount_needed) + ' ב-12 החודשים הקרובים, ואת/ה בדרגת <b>' +
      esc(n.label) + '</b>.</p>'
    );
  }

  /** "עוד 2 קניות או עוד 150 ₪" — only the conditions the program uses. */
  function needText(o, a) {
    var parts = [];
    if (o != null) parts.push('עוד <b>' + o + '</b> קניות');
    if (a != null) parts.push('עוד <b>' + a + ' ₪</b>');
    return parts.join(' או ');
  }

  // ---------- refer-a-friend: remember the friend's code for 30 days ----------
  function saveRef() {
    var m = /[?&]ref=([A-Za-z0-9]{4,12})/.exec(location.search);
    if (!m) return;
    var src = (/[?&]s=([wc])/.exec(location.search) || [])[1] || '';
    try { localStorage.setItem('hc-ref', JSON.stringify({ c: m[1].toUpperCase(), s: src, t: Date.now() })); } catch (e) {}
  }
  function getRef() {
    try {
      var r = JSON.parse(localStorage.getItem('hc-ref') || 'null');
      if (r && Date.now() - r.t < 30 * 86400000) return r.c;
    } catch (e) {}
    return '';
  }
  function getRefSource() {
    try { var r = JSON.parse(localStorage.getItem('hc-ref') || 'null'); return (r && r.s) || ''; } catch (e) { return ''; }
  }
  function refBanner(host) {
    if (!getRef() || !host || host.querySelector('.hc-refbanner')) return;
    var b = document.createElement('div');
    b.className = 'hc-refbanner';
    b.innerHTML = '✨ <b>חבר/ה הזמין/ה אותך!</b> לקוחות חדשים מצטרפים עכשיו ומקבלים <b>' + amt(friendTotal()) + ' מתנה</b> לקנייה הראשונה (' + amt(giftAmt()) + ' + ' + amt(pg('referral.friend_bonus', 10)) + ' בונוס חבר).';
    host.insertBefore(b, host.firstChild);
  }

  // ---------- countdowns ----------
  // "2026-10-24T20:00" (no zone) = Israel local time; anything else is parsed as given.
  function toTime(end) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})$/.exec(String(end).trim());
    if (!m) return new Date(end).getTime();
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var il = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' }));
    var utc = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'UTC' }));
    return guess - (il - utc);
  }
  function left(end) {
    var ms = toTime(end) - Date.now();
    if (!(ms > 0)) return null;
    return { d: Math.floor(ms / 86400000), h: Math.floor(ms / 3600000) % 24, m: Math.floor(ms / 60000) % 60, s: Math.floor(ms / 1000) % 60 };
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function countdownText(end) {
    var t = left(end);
    if (!t) return 'הסתיים';
    if (t.d >= 3) return 'נשארו ' + t.d + ' ימים';
    var clock = '<bdi dir="ltr" class="hc-clock">' + two(t.h) + ':' + two(t.m) + ':' + two(t.s) + '</bdi>';
    return (t.d === 1 ? 'יום ו-' : t.d === 2 ? 'יומיים ו-' : '') + clock;
  }
  function startCountdowns(scope) {
    var els = (scope || document).querySelectorAll('[data-hc-countdown]:not([data-hc-ticking])');
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-hc-ticking', ''); });
    function tick() {
      els.forEach(function (el) {
        el.innerHTML = countdownText(el.getAttribute('data-hc-countdown'));
        if (!left(el.getAttribute('data-hc-countdown'))) el.closest('[data-hc-countdown-box]') && (el.closest('[data-hc-countdown-box]').hidden = true);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function money(n) { return amt(Math.max(0, Math.floor(Number(n) || 0))); }
  function dateHe(d) { return new Date(d).toLocaleDateString('he-IL', { day: 'numeric', month: 'long' }); }

  function renderMember(root, s) {
    var justJoined = false;
    try { justJoined = sessionStorage.getItem('hc-joined') === '1'; sessionStorage.removeItem('hc-joined'); } catch (e) {}
    var ledger = (s.ledger || []).slice(0, 10)
      .map(function (l) {
        return (
          '<li><span>' + new Date(l.created_at).toLocaleDateString('he-IL') + '</span><span>' + esc(REASONS[l.reason] || l.reason) +
          '</span><b class="' + (l.delta > 0 ? 'hc-plus' : 'hc-minus') + '">' + (l.delta > 0 ? '+' : '') + amt(l.delta) + '</b></li>'
        );
      })
      .join('');
    var codes = (s.active_codes || [])
      .map(function (c) {
        return '<li><code>' + esc(c.discount_code) + '</code> · ' + shk(c.points) + ' ₪ · עד ' + dateHe(c.expires_at) + '</li>';
      })
      .join('');
    var gift = s.join_gift && s.join_gift.status === 'usable'
      ? '<div class="hc-note hc-note--gift" data-hc-countdown-box>⏳ <span><b>' + amt(giftAmt()) + ' מתנת הצטרפות</b> כלולים ביתרה. ' +
        '<b class="hc-timer" data-hc-countdown="' + esc(s.join_gift.expires_at) + '"></b> לנצל אותם (עד ' + dateHe(s.join_gift.expires_at) + ').</span></div>'
      : '';
    var bday = s.birthday
      ? '<div class="hc-note hc-note--bday">🎂 <span><b>יום הולדת שמח!</b> החודש מגיעה לך ' + s.birthday.percent + '% הנחה על קנייה אחת (במקום הנקודות).' +
        (s.birthday.code ? ' הקוד שלך: <code>' + esc(s.birthday.code) + '</code>' : ' <button type="button" class="hc-link" data-hc-bday-use>להפעלה בעגלה</button>') +
        '</span></div>'
      : '';
    var progress = '';
    if (s.next_tier) {
      var n = s.next_tier;
      progress = '<p class="hc-home__next">' + needText(n.orders_needed, n.amount_needed) + ' השנה, ואת/ה ב' + esc(n.label) + '.</p>';
    }
    var P = s.profile || {};
    var B = P.benefits || {};
    var tiers = ['bronze', 'silver', 'gold', 'platinum', 'diamond'].filter(function (t) { return B[t]; });
    function pct(v, max) { return max ? Math.min(100, Math.round((v / max) * 100)) : 0; }
    function bar(label, v, max, unit) {
      return '<div class="hc-prog"><div class="hc-prog__top"><span>' + label + '</span><b>' + v + (unit || '') + ' / ' + max + (unit || '') + '</b></div>' +
        '<div class="hc-prog__track"><div class="hc-prog__fill" style="width:' + pct(v, max) + '%"></div></div></div>';
    }
    var tierBox = '';
    if (P.next) {
      var needO = P.next.orders ? Math.max(0, P.next.orders - P.orders_12m) : null;
      var needA = P.next.amount ? Math.max(0, P.next.amount - P.amount_12m) : null;
      tierBox = '<div class="hc-box"><h3>הדרך לדרגת ' + esc(P.next.label) + '</h3>' +
        '<p class="hc-muted">' + (P.next.orders && P.next.amount ? 'מספיק אחד מהשניים, ' : '') + 'ב-12 החודשים האחרונים:</p>' +
        (P.next.orders ? bar('קניות', P.orders_12m, P.next.orders) : '') + (P.next.amount ? bar('סכום קניות', P.amount_12m, P.next.amount, ' ₪') : '') +
        '<p>' + needText(needO, needA) + ' ואת/ה ב' + esc(P.next.label) + '.</p></div>';
    } else if (tiers.length > 1) {
      tierBox = '<div class="hc-box"><h3>את/ה בדרגה הגבוהה ביותר 🥇</h3><p class="hc-muted">תודה שאת/ה איתנו.</p></div>';
    }
    if (P.keep) {
      tierBox += '<div class="hc-box hc-box--soft"><h3>שמירה על הדרגה</h3><p>כדי להישאר ב' + esc(s.tier_label) + ' אחרי <b>' + dateHe(P.keep.until) + '</b>: ' +
        [P.keep.orders ? P.keep.orders + ' קניות' : '', P.keep.amount ? P.keep.amount + ' ₪' : ''].filter(Boolean).join(' או ') + ' ב-12 החודשים שלפני. כרגע: ' + P.orders_12m + ' קניות, ' + P.amount_12m + ' ₪.</p></div>';
    }
    function cell(t, html) { return '<span class="' + (t === s.tier ? 'is-me' : '') + '">' + html + '</span>'; }
    var benefits = tiers.length < 2 ? '' : '<div class="hc-box"><h3>ההטבות לפי דרגה</h3><div class="hc-btable" role="table">' +
      '<div class="hc-btable__row hc-btable__head" role="row"><span></span>' + tiers.map(function (t) {
        return '<span class="' + (t === s.tier ? 'is-me' : '') + '">' + esc((B[t] || {}).label || t) + (t === s.tier ? '<small>הדרגה שלך</small>' : '') + '</span>';
      }).join('') + '</div>' +
      '<div class="hc-btable__row" role="row"><span>' + (isPoints() ? 'נקודות' : 'חוזר אליך') + ' על כל 100 ₪</span>' + tiers.map(function (t) { return cell(t, amt(B[t].rate)); }).join('') + '</div>' +
      (tiers.some(function (t) { return B[t].ship_from; })
        ? '<div class="hc-btable__row" role="row"><span>משלוח חינם עד הבית</span>' + tiers.map(function (t) { return cell(t, B[t].ship_from ? 'מעל ' + B[t].ship_from + ' ₪' : '—'); }).join('') + '</div>' : '') +
      (tiers.some(function (t) { return B[t].birthday; })
        ? '<div class="hc-btable__row" role="row"><span>הנחת יום הולדת</span>' + tiers.map(function (t) { return cell(t, B[t].birthday ? B[t].birthday + '%' : '—'); }).join('') + '</div>' : '') +
      '</div></div>';
    var soon = P.points_expire_at && new Date(P.points_expire_at) - Date.now() < 30 * 86400000;
    var expiry = (P.points_expire_at
      ? (soon
        ? '<span class="hc-me__warn">⏳ היתרה פגה ב-<b>' + dateHe(P.points_expire_at) + '</b>. קנייה חדשה מאריכה את התוקף</span>'
        : '<span>היתרה בתוקף עד <b>' + dateHe(P.points_expire_at) + '</b> (מתחדש בכל קנייה)</span>')
      : '') +
      (s.join_gift && s.join_gift.status === 'usable'
        ? '<span data-hc-countdown-box>⏳ מתוכם ' + amt(giftAmt()) + ' מתנת הצטרפות: <b data-hc-countdown="' + esc(s.join_gift.expires_at) + '"></b></span>' : '');
    root.innerHTML =
      (justJoined ? '<div class="hc-welcome">🎉 <b>ברוכים הבאים למשפחה!</b> ההצטרפות הצליחה.</div>' : '') +
      '<section class="hc-me">' +
        '<div class="hc-me__top"><div><p class="hc-eyebrow">מועדון החברים · חבר/ה מאז ' + (P.since ? dateHe(P.since) : '') + '</p>' +
          '<h1 class="hc-home__hi">שלום ' + esc(s.first_name || '') + ' 💚</h1></div>' +
          '<span class="hc-pill hc-tier--' + esc(s.tier) + '">' + esc(s.tier_label) + '</span></div>' +
        '<div class="hc-me__balance"><span>יש לך לשימוש</span><b>' + money(s.balance) + '</b>' + (expiry ? '<div class="hc-me__exp">' + expiry + '</div>' : '') + '</div>' +
        '<div class="hc-me__actions"><a class="hc-btn hc-btn--light" href="/collections/all">לקניות</a>' +
          '<a class="hc-btn hc-btn--ghost" href="/account">ההזמנות שלי</a></div>' +
        (root.dataset.logout ? '<p class="hc-me__logout"><a href="' + esc(root.dataset.logout) + '">התנתקות</a></p>' : '') +
        '<p class="hc-me__how">איך משתמשים? בעגלה לוחצים <b>"השתמש בנקודות"</b> וההנחה יורדת מהמחיר (עד ' + maxShare() + '% מההזמנה).</p>' +
      '</section>' +
      bday +
      '<div class="hc-grid2">' + tierBox + '</div>' +
      benefits +
      '<h2 class="hc-subtitle">עוד דרכים לצבור</h2>' +
      (s.referral && pg('referral.enabled', true)
        ? '<div class="hc-ref"><div class="hc-ref__head"><b>🎁 חבר מביא חבר</b><span>החבר/ה מקבל/ת <b>' + amt(friendTotal()) + '</b> על הקנייה הראשונה, ואת/ה <b>' + amt(pg('referral.referrer_reward', 20)) + '</b> כשהוא/היא קונה' + (pg('referral.min_order', 100) ? ' (מעל ' + pg('referral.min_order', 100) + ' ₪)' : '') + '</span></div>' +
          '<div class="hc-ref__row"><input readonly value="' + esc(s.referral.link + '&s=c') + '" aria-label="הקישור האישי שלך" dir="ltr">' +
          '<button type="button" class="hc-btn hc-btn--green hc-ref__copy" data-hc-copy>העתקה</button></div>' +
          '<a class="hc-ref__wa" target="_blank" rel="noopener" href="https://wa.me/?text=' + encodeURIComponent('הצטרפתי למועדון החברים של הפי המפי 💚 עם הקישור שלי מקבלים ' + amt(friendTotal()) + ' מתנה לקנייה הראשונה: ' + s.referral.link + '&s=w') + '" data-hc-wa>שיתוף בוואטסאפ</a>' +
          (s.referral.joined ? '<p class="hc-muted">הצטרפו דרכך: ' + s.referral.joined + ' · קנו: ' + s.referral.rewarded + '</p>' : '') + '</div>'
        : '') +
      (s.instagram_done === false
        ? '<button type="button" class="hc-ig" data-hc-ig>📸 <span><b>עקבו אחרינו באינסטגרם</b> וקבלו ' + amt(pg('instagram.amount', 5)) + ' לחשבון</span></button>'
        : '') +
      (s.telegram_done === false
        ? '<button type="button" class="hc-ig hc-tg" data-hc-tg>✈️ <span><b>הצטרפו לערוץ הטלגרם</b> וקבלו ' + amt(pg('telegram.amount', 5)) + ' לחשבון</span></button>'
        : '') +
      '<div class="hc-box hc-box--plain"><span>🛍️ <b>כל קנייה:</b> ' + amt(s.earn_rate) + ' על כל 100 ₪</span>' +
        (pg('second_order.enabled', true) ? '<span>🔁 <b>קנייה שנייה תוך ' + pg('second_order.days', 60) + ' יום:</b> פי ' + pg('second_order.multiplier', 2) + '</span>' : '') +
        (pg('birthday.enabled', true) ? '<span>🎂 <b>יום הולדת:</b> הנחה בחודש שלך</span>' : '') + '</div>' +
      '<details class="hc-more"><summary>היסטוריה וקודי הנחה</summary>' +
      (codes ? '<h4>קודים פעילים</h4><ul class="hc-codes">' + codes + '</ul>' : '') +
      (s.can_redeem
        ? '<div class="hc-row"><input type="number" min="' + s.min_redeem + '" max="' + s.redeemable_points + '" value="' + s.redeemable_points +
          '" data-hc-points aria-label="כמה נקודות לממש"> <button class="button button--secondary" data-hc-make>יצירת קוד הנחה</button></div><p data-hc-out></p>'
        : (s.redeem_blocked_reason ? '<p class="hc-muted">' + esc(s.redeem_blocked_reason) + '</p>' : '')) +
      (ledger ? '<ul class="hc-ledger">' + ledger + '</ul>' : '<p class="hc-muted">עוד אין תנועות.</p>') +
      '</details>';

    startCountdowns(root);
    var copy = root.querySelector('[data-hc-copy]');
    if (copy) {
      copy.onclick = function () {
        var inp = root.querySelector('.hc-ref__row input');
        inp.select();
        (navigator.clipboard ? navigator.clipboard.writeText(inp.value) : Promise.reject()).catch(function () { document.execCommand('copy'); });
        copy.textContent = 'הועתק ✓';
        call('share', { channel: 'copy' });
        setTimeout(function () { copy.textContent = 'העתקה'; }, 2000);
      };
    }
    var wa = root.querySelector('[data-hc-wa]');
    if (wa) wa.addEventListener('click', function () { call('share', { channel: 'whatsapp' }); });
    var ig = root.querySelector('[data-hc-ig]');
    if (ig) {
      ig.onclick = function () {
        var w = window.open('https://instagram.com/happyhempy_il', '_blank', 'noopener');
        ig.disabled = true;
        call('instagram', {}).then(function (r) {
          if (!w && r && r.url) location.href = r.url;
          setTimeout(function () { loadPage(root); }, 800);
        });
      };
    }
    var tg = root.querySelector('[data-hc-tg]');
    if (tg) {
      tg.onclick = function () {
        var w = window.open('https://t.me/happyhempy', '_blank', 'noopener');
        tg.disabled = true;
        call('telegram', {}).then(function (r) {
          if (!w && r && r.url) location.href = r.url;
          setTimeout(function () { loadPage(root); }, 800);
        });
      };
    }
    var bdayBtn = root.querySelector('[data-hc-bday-use]');
    if (bdayBtn) {
      bdayBtn.onclick = function () {
        useBirthday(bdayBtn, function () { bdayBtn.outerHTML = '✅ הוחל על העגלה.'; });
      };
    }
    var make = root.querySelector('[data-hc-make]');
    if (make) {
      make.onclick = function () {
        var out = root.querySelector('[data-hc-out]');
        var pts = Math.floor(Number(root.querySelector('[data-hc-points]').value));
        make.disabled = true;
        call('redeem', { points: pts }).then(function (r) {
          make.disabled = false;
          if (!r.ok) { out.textContent = r.message; return; }
          applyCode(r.code);
          out.innerHTML = '✅ ' + esc(r.message) + ' הקוד הוחל על העגלה.';
        });
      };
    }
  }

  var REGIONS = ['צפון', 'חיפה והקריות', 'שרון', 'מרכז', 'תל אביב והסביבה', 'ירושלים והסביבה', 'שפלה', 'דרום', 'אילת והערבה', 'יהודה ושומרון'];

  var MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
  function range(a, b) { var r = []; for (var x = a; x <= b; x++) r.push(x); return r; }
  function years() {
    var y = new Date().getFullYear();
    return range(y - 90, y - 16).reverse().map(function (v) { return '<option>' + v + '</option>'; }).join('');
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function renderJoin(root, saved, buyer) {
    var first = (root.dataset.firstName || '');
    var last = (root.dataset.lastName || '');
    root.innerHTML =
      '<form id="hc-join" class="hc-card hc-join hc-join-form' + (saved > 0 ? ' hc-saved' : '') + '" novalidate>' +
      (saved > 0
        ? '<h3>⭐ יש לך ' + amt(saved) + (isPoints() ? '' : ' בנקודות') + ' שמחכות לך!</h3><p>צברת אותן על הקניות שלך. מצטרפים עכשיו, משתמשים בהן' + (giftAmt() ? ', ומקבלים עוד ' + amt(giftAmt()) + ' מתנה מיד' : '') + '.</p>'
        : '<p class="hc-eyebrow">עוד צעד אחד</p><h3>' + (first ? 'שלום ' + esc(first) + '! ' : '') + 'מצטרפים למשפחת המפי</h3><p>ההצטרפות בחינם' + (giftAmt() ? ', ומקבלים ' + amt(giftAmt()) + ' מתנה לשימוש כבר עכשיו' : '') + '.</p>') +
      '<div class="hc-fields">' +
      '<label>שם פרטי *<input name="first_name" autocomplete="given-name" required maxlength="40" value="' + esc(first) + '"></label>' +
      '<label>שם משפחה *<input name="last_name" autocomplete="family-name" required maxlength="40" value="' + esc(last) + '"></label>' +
      '<fieldset class="hc-bdate"><legend>תאריך לידה *</legend><div class="hc-bdate__row">' +
      '<select name="bday_y" required aria-label="שנה"><option value="">שנה</option>' + years() + '</select>' +
      '<select name="bday_m" required aria-label="חודש"><option value="">חודש</option>' + MONTHS.map(function (m, k) { return '<option value="' + (k + 1) + '">' + m + '</option>'; }).join('') + '</select>' +
      '<select name="bday_d" required aria-label="יום"><option value="">יום</option>' + range(1, 31).map(function (d) { return '<option>' + d + '</option>'; }).join('') + '</select>' +
      '</div></fieldset>' +
      '<label>טלפון נייד' + (buyer ? '' : ' *') + '<input name="phone" type="tel" inputmode="tel" autocomplete="tel" dir="ltr" placeholder="050-1234567"' + (buyer ? '' : ' required') + '></label>' +
      '<label><span>עיר מגורים <span class="hc-opt">(לא חובה)</span></span><input name="region" autocomplete="address-level2" maxlength="40" placeholder="למשל: חיפה"></label>' +
      '<fieldset class="hc-gender"><legend>מגדר *</legend>' +
      '<label><input type="radio" name="gender" value="female" required> נקבה</label>' +
      '<label><input type="radio" name="gender" value="male"> זכר</label>' +
      '<label><input type="radio" name="gender" value="other"> אחר</label></fieldset>' +
      '</div>' +
      '<label class="hc-terms"><input type="checkbox" name="terms"> קראתי ואני מאשר/ת את <a href="/pages/hempy-club-terms" target="_blank">תקנון המועדון</a>. אני בן/בת 18 ומעלה, או בן/בת 16–17 והוריי מסכימים להצטרפות. הפרטים משמשים לניהול הנקודות וההטבות שלי.</label>' +
      '<label class="hc-terms"><input type="checkbox" name="marketing"> אני מאשר/ת לקבל מהפי המפי מבצעים ועדכונים על הטבות המועדון במייל וב-SMS. אפשר להסיר את עצמי בכל עת.</label>' +
      '<button class="button" type="submit">הצטרפות למועדון</button><p data-hc-join-out role="status"></p></form>';
    var form = root.querySelector('form');
    form.onsubmit = function (e) {
      e.preventDefault();
      var out = root.querySelector('[data-hc-join-out]');
      var f = new FormData(form);
      var data = {
        first_name: f.get('first_name'),
        last_name: f.get('last_name'),
        region: f.get('region'),
        phone: f.get('phone'),
        gender: f.get('gender'),
        ref: getRef(),
        ref_source: getRefSource(),
        birthday: f.get('bday_y') && f.get('bday_m') && f.get('bday_d')
          ? f.get('bday_y') + '-' + pad(Number(f.get('bday_m'))) + '-' + pad(Number(f.get('bday_d')))
          : '',
        terms: form.elements.terms.checked,
        marketing: form.elements.marketing.checked
      };
      var btn = form.querySelector('button[type=submit]');
      if (!form.checkValidity()) { form.reportValidity(); return; }
      if (!form.elements.terms.checked) { out.textContent = 'יש לאשר את תקנון המועדון'; return; }
      if (!form.elements.marketing.checked) { out.textContent = 'ההצטרפות למועדון כוללת קבלת עדכונים על מבצעים והטבות. יש לסמן את האישור'; return; }
      btn.disabled = true;
      call('join', data).then(function (r) {
        out.textContent = r.message || '';
        if (r.ok) {
          try { sessionStorage.setItem('hc-joined', '1'); localStorage.removeItem('hc-ref'); } catch (e) {}
          loadPage(root);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else btn.disabled = false;
      });
    };
  }

  function loadPage(root) {
    root.innerHTML = '<p class="hc-muted">טוען...</p>';
    call('status').then(function (s) {
      if (!s.ok) { root.innerHTML = '<p>' + esc(s.message || 'המועדון לא זמין כרגע') + '</p>'; return; }
      if (!s.member) {
        renderJoin(root, Number(s.saved_points || 0), !!s.buyer);
        return;
      }
      renderMember(root, s);
    });
  }

  function previewMember() {
    if (!/[?&]hc_preview_member=1/.test(location.search)) return;
    var host = document.querySelector('.hc-wrap');
    if (!host) return;
    var box = document.createElement('div');
    box.className = 'hc-member';
    host.insertBefore(box, host.firstChild);
    var soon = new Date(Date.now() + 41 * 86400000).toISOString();
    renderMember(box, {
      first_name: 'דוגמה', balance: 35, tier: 'bronze', tier_label: 'ארד', earn_rate: 5, can_redeem: true, redeemable_points: 35, min_redeem: 5,
      ledger: [{ created_at: new Date().toISOString(), reason: 'join_bonus', delta: 20 }, { created_at: new Date().toISOString(), reason: 'order_earn', delta: 15 }],
      active_codes: [], join_gift: { status: 'usable', expires_at: soon }, instagram_done: false, telegram_done: false,
      referral: { code: 'ABC234', link: 'https://www.happy-hempy.com/pages/hempy-club?ref=ABC234', joined: 0, rewarded: 0 },
      profile: { since: new Date().toISOString(), points_expire_at: new Date(Date.now() + 540 * 86400000).toISOString(), orders_12m: 2, amount_12m: 230,
        next: { tier: 'silver', label: 'כסף', orders: 5, amount: 400 }, keep: null,
        benefits: { bronze: { label: 'ארד', rate: 5, ship_from: 230, birthday: 10 }, silver: { label: 'כסף', rate: 7, ship_from: 150, birthday: 15 }, gold: { label: 'זהב', rate: 10, ship_from: 100, birthday: 20 } } }
    });
  }

  function previewJoin() {
    if (!/[?&]hc_preview_join=1/.test(location.search)) return;
    var host = document.querySelector('.hc-wrap');
    if (!host || document.getElementById('hc-join')) return;
    var box = document.createElement('div');
    host.insertBefore(box, host.firstChild);
    renderJoin(box, 0, false);
  }

  function init() {
    initCarts();
    document.querySelectorAll('[data-hc-page]:not([data-hc-ready])').forEach(function (root) {
      root.setAttribute('data-hc-ready', '');
      loadPage(root);
    });
  }

  // ---------- floating club button ----------
  function initFab() {
    var fabs = document.querySelectorAll('[data-hc-fab]');
    // The header may render twice (sticky copy); keep one button.
    for (var i = 1; i < fabs.length; i++) fabs[i].remove();
    var fab = fabs[0];
    if (!fab || fab.hasAttribute('data-hc-ready')) return;
    fab.setAttribute('data-hc-ready', '');
    document.body.appendChild(fab);
    var btn = fab.querySelector('.hc-fab__btn');
    var panel = fab.querySelector('.hc-fab__panel');
    function set(open) {
      panel.hidden = !open;
      fab.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('.hc-fab__close').focus();
    }
    fab.querySelectorAll('[data-hc-fab-toggle]').forEach(function (t) {
      t.addEventListener('click', function () { set(panel.hidden); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !fab.contains(e.target)) set(false);
    });
    phoneBehaviour(fab, panel);
  }

  // Phones: full label only on the first page of the visit (5s), then a small star.
  // Slides away while scrolling down and while a drawer/menu is open; comes back on scroll up.
  function phoneBehaviour(fab, panel) {
    var phone = window.matchMedia('(max-width: 749px)');
    var seen = false;
    try { seen = sessionStorage.getItem('hc-fab-seen') === '1'; sessionStorage.setItem('hc-fab-seen', '1'); } catch (e) {}
    function compact(on) { fab.classList.toggle('is-compact', on && phone.matches); }
    compact(seen);
    if (!seen) setTimeout(function () { if (panel.hidden) compact(true); }, 5000);
    var lastY = window.scrollY, timer;
    window.addEventListener('scroll', function () {
      if (!phone.matches || !panel.hidden) return;
      var y = window.scrollY;
      if (Math.abs(y - lastY) < 8) return;
      compact(true);
      fab.classList.toggle('is-away', y > lastY && y > 300);
      lastY = y;
      clearTimeout(timer);
      timer = setTimeout(function () { fab.classList.remove('is-away'); }, 1200);
    }, { passive: true });
    new MutationObserver(function () {
      var drawer = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile') ||
        document.body.classList.contains('overflow-hidden-tablet');
      if (phone.matches) fab.classList.toggle('is-away', drawer);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- product page: "you'll get X back" (like Smile / Rivo / LoyaltyLion) ----------
  function readPrice(box) {
    var el = box.querySelector('.price--on-sale .price-item--sale') || box.querySelector('.price-item--sale:not(:empty)') ||
      box.querySelector('.price-item--regular') || box.querySelector('.price-item');
    if (!el) return 0;
    var t = el.textContent.replace(/[^\d.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }
  function productBadge() {
    if (pg('branding.show_product_badge', true) === false) return;
    var box = document.querySelector('main .product-page-price');
    if (!box || box.parentNode.querySelector('.hc-earn')) return;
    var badge = document.createElement('div');
    badge.className = 'hc-earn';
    box.insertAdjacentElement('afterend', badge);
    function render() {
      var price = readPrice(box);
      if (!price) { badge.hidden = true; return; }
      var member = !!HC.member;
      var tier = member ? (HC.tier || 'bronze') : 'bronze';
      var c = activeCampaign();
      var mult = c && (c.type === 'multiplier' || !c.type) ? Number(c.multiplier) || 1 : 1;
      var pts = Math.floor(price * tierRateOf(tier) / 100 * (member ? mult : 1));
      if (pts < 1) { badge.hidden = true; return; }
      badge.hidden = false;
      var icon = pg('branding.launcher_icon', '⭐');
      var link = HC.logged_in ? (HC.club_url || '/pages/hempy-club') : (HC.club_url || '/pages/hempy-club');
      badge.innerHTML = member
        ? icon + ' <span>על המוצר הזה תקבלו <b>' + amt(pts) + '</b>' + (isPoints() ? '' : ' חזרה') + ' לקנייה הבאה' +
            (c ? ' <em>' + esc(c.name) + ' · ' + esc(campaignText(c)) + '</em>' : '') + '</span>'
        : icon + ' <span>חברי מועדון מקבלים <b>' + amt(pts) + '</b>' + (isPoints() ? '' : ' חזרה') + ' על המוצר הזה' +
            (giftAmt() ? ' + ' + amt(giftAmt()) + ' מתנה בהצטרפות' : '') + '. <a href="' + esc(link) + '">הצטרפות בחינם</a></span>';
    }
    render();
    // Variant changes re-render the price block.
    new MutationObserver(render).observe(box, { childList: true, subtree: true, characterData: true });
  }

  // ---------- campaign ribbon on the club page ----------
  function campaignRibbon() {
    var c = activeCampaign();
    var root = document.querySelector('.hc-wrap');
    if (!c || !root || root.querySelector('.hc-camp')) return;
    var d = document.createElement('div');
    d.className = 'hc-camp';
    d.innerHTML = '🔥 <b>' + esc(c.name) + '</b> · ' + esc(campaignText(c)) + ', עד ' + dateHe(c.ends_at);
    root.insertBefore(d, root.firstChild);
  }

  document.addEventListener('DOMContentLoaded', productBadge);
  document.addEventListener('DOMContentLoaded', campaignRibbon);
  document.addEventListener('DOMContentLoaded', initFab);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('DOMContentLoaded', previewJoin);
  document.addEventListener('DOMContentLoaded', previewMember);
  saveRef();
  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.querySelector('.hc-wrap');
    if (wrap && !(window.hcIsMember)) refBanner(wrap);
  });
  document.addEventListener('DOMContentLoaded', function () { startCountdowns(document); });
  // The theme re-renders the cart drawer after every cart change.
  new MutationObserver(initCarts).observe(document.documentElement, { childList: true, subtree: true });
})();
